var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_765_320)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 36,
    r: 36,
    fill: "white",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_765_320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8144 13.3043H44.803C40.6561 13.3028 36.5896 14.4478 33.0527 16.6129C29.5159 18.7779 26.6464 21.8787 24.7616 25.5725C22.8768 29.2662 22.0499 33.4092 22.3723 37.5436C22.6947 41.6779 24.1539 45.6426 26.5887 48.9995L23.784 57.3595L32.4342 54.5946C35.363 56.5241 38.7023 57.7421 42.1855 58.1516C45.6688 58.5611 49.1995 58.1506 52.4959 56.953C55.7923 55.7554 58.7631 53.8038 61.1712 51.2539C63.5792 48.7041 65.3579 45.6266 66.3652 42.2671C67.3725 38.9077 67.5805 35.3592 66.9726 31.9051C66.3647 28.451 64.9578 25.1868 62.8641 22.373C60.7705 19.5593 58.0481 17.2739 54.9142 15.6993C51.7803 14.1248 48.3217 13.3046 44.8144 13.3043Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9095 45.082C57.3666 46.6153 55.2132 47.8867 53.493 48.2582C52.3171 48.5086 50.7812 48.7084 45.6106 46.5646C38.9969 43.8225 34.738 37.1046 34.4063 36.6681C34.0864 36.2322 31.7337 33.1094 31.7337 29.8803C31.7045 28.856 31.8947 27.8374 32.2916 26.8927C32.6884 25.948 33.2828 25.0991 34.0347 24.4031C34.6689 23.8473 35.4933 23.5579 36.3357 23.5955C36.614 23.5955 36.8645 23.6097 37.0898 23.6207C37.7511 23.649 38.0828 23.6883 38.5188 24.7317C39.0618 26.0396 40.3839 29.2692 40.5415 29.601C40.6529 29.7819 40.7196 29.9867 40.7362 30.1985C40.7528 30.4102 40.7188 30.6229 40.637 30.8189C40.4521 31.2005 40.2061 31.5492 39.9086 31.8513C39.5768 32.2338 39.2615 32.5263 38.9297 32.9372C38.6258 33.2945 38.2826 33.677 38.6651 34.3379C39.654 36.0207 40.8842 37.5495 42.3165 38.8755C43.8548 40.2833 45.6454 41.3876 47.594 42.1302C47.853 42.2531 48.143 42.295 48.4261 42.2503C48.7092 42.2056 48.9722 42.0765 49.1807 41.8798C49.808 41.1349 50.3949 40.3569 50.9388 39.5491C51.0991 39.2816 51.3532 39.0833 51.6517 38.9929C51.9501 38.9024 52.2716 38.9262 52.5534 39.0596C53.1612 39.2708 56.3763 40.8602 57.0375 41.1893C57.6988 41.5183 58.1343 41.6787 58.2948 41.957C58.4552 42.2354 58.4524 43.5479 57.9095 45.082Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_765_320",
    x: 0,
    y: 0,
    width: 90,
    height: 91,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_765_320"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_765_320",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_765_320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.0094,
    height: 45.0094,
    fill: "white",
    transform: "translate(22.3043 13.3043)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatapp);
export default __webpack_public_path__ + "static/media/whatapp.fb0fafebb40e9ece4964f26808d83b8d.svg";
export { ForwardRef as ReactComponent };